<template>
	<div class="mask-guidelines">
		<!-- 一开始介绍 -->
		<div class="guidelines-i0 bg-w" v-show="active == 0">
			<div class="title-guidelines">
				西顿智能设计岛全面升级
				<div class="jump-next" @click="allClick('out')">跳过</div>
			</div>

			<div class="content-guidelines">
				西顿智能设计岛全面升级， 升级后账户订单信息、余额信息，积分信息不不受影响，
				如果您有任何疑问或需要帮助， 欢迎拨打客服热线
				<span>0752-5333672</span>
				进行咨询。
			</div>
			<div class="bottom-guidelines">
				<steps
					:unactivecolor="'rgba(204, 204, 204, 0.5)'"
					:activecolor="'#e60000'"
					:active="active"
					:step="step"
					@allClick="allClick"
				></steps>
			</div>
		</div>
		<!-- 流程 -->
		<div class="guidelines-i1-img" ref="leftProcess" v-show="active == 1">
			<img class="img-line" src="../assets/imgs/liucheng@2x.png" alt="" />

			<div class="guidelines-i1">
				<img class="bg-border-i1" src="../assets/imgs/kuang.png" alt="" />
				<div class="title-guidelines">
					下单流程
					<div class="jump-next" @click="allClick('out')">跳过</div>
				</div>

				<div class="content-guidelines"> 设计下单——需求沟通——订单支付——方案验收 </div>
				<div class="bottom-guidelines">
					<steps
						:unactivecolor="'rgba(204, 204, 204, 0.5)'"
						:activecolor="'#e60000'"
						:active="active"
						:step="step"
						@allClick="allClick"
					></steps>
				</div>
			</div>
		</div>
		<!-- 下单人信息 -->
		<div class="guidelines-i2-img" ref="essential" v-show="active == 2">
			<img class="img-line" src="../assets/imgs/tu3.png" alt="" />
			<div class="guidelines-i2">
				<img class="bg-border-i2" src="../assets/imgs/kuang3.png" alt="" />
				<div class="title-guidelines">
					下单人信息
					<div class="jump-next" @click="allClick('out')">跳过</div>
				</div>

				<div class="content-guidelines"> 第一步：填写下单人姓名、手机号码、邮箱 </div>
				<div class="bottom-guidelines">
					<steps
						:unactivecolor="'rgba(204, 204, 204, 0.5)'"
						:activecolor="'#e60000'"
						:active="active"
						:step="step"
						@allClick="allClick"
					></steps>
				</div>
			</div>
		</div>
		<!-- 项目信息 -->
		<div class="guidelines-i3-img" ref="ruleForm" v-show="active == 3">
			<img class="img-line" src="../assets/imgs/tu4.png" alt="" />
			<div class="guidelines-i3">
				<img class="bg-border-i3" src="../assets/imgs/kuang4.png" alt="" />
				<div class="title-guidelines">
					项目信息
					<div class="jump-next" @click="allClick('out')">跳过</div>
				</div>

				<div class="content-guidelines">
					<p>第二步：填写填写姓名信息</p>
					<p>1. 选择项目业态</p>
					<p>2. 填写姓名名称</p>
					<p>3. 填写设计面积</p>
					<p>4. 可选择相关项目，若无可不选择</p>
					<p>5. 选择指定产品，若无可不选择</p>
					<p>6. 可填写备注信息</p>
				</div>
				<div class="bottom-guidelines">
					<steps
						:unactivecolor="'rgba(204, 204, 204, 0.5)'"
						:activecolor="'#e60000'"
						:active="active"
						:step="step"
						@allClick="allClick"
					></steps>
				</div>
			</div>
		</div>
		<!-- 需求信息 -->
		<div class="guidelines-i4-img" ref="serveForm" v-show="active == 4">
			<img class="img-line" src="../assets/imgs/tu5.png" alt="" />
			<div class="guidelines-i4">
				<img class="bg-border-i4" src="../assets/imgs/kuang5.png" alt="" />
				<div class="title-guidelines">
					需求信息
					<div class="jump-next" @click="allClick('out')">跳过</div>
				</div>

				<div class="content-guidelines">
					<p>第三步：填写需求信息</p>
					<p>1. 按需选择服务项（可单选或多选）</p>
					<p>2. 价格与需求项、项目信息有关</p>
					<p>3. 点击需求明细可查看对应的交付资料</p>
				</div>
				<div class="bottom-guidelines">
					<steps
						:unactivecolor="'rgba(204, 204, 204, 0.5)'"
						:activecolor="'#e60000'"
						:active="active"
						:step="step"
						@allClick="allClick"
					></steps>
				</div>
			</div>
		</div>
		<!-- 上传图片 -->
		<div class="guidelines-i5-img" ref="imgUpload" v-show="active == 5">
			<img class="img-line" src="../assets/imgs/tu6@2x.png" alt="" />
			<div class="guidelines-i5">
				<img class="bg-border-i5" src="../assets/imgs/kuang6@2x.png" alt="" />
				<div class="title-guidelines">
					图纸上传
					<div class="jump-next" @click="allClick('out')">跳过</div>
				</div>

				<div class="content-guidelines">
					<p>第四步：上传与项目有关的图纸</p>
					<p>1. 基础需求图纸：平面布置图、立面布置图、天花图等</p>
					<p>2. 支持多种格式上传，如jpg、png、dwg、zip等</p>
					<p>3. 点击“示意图纸”可查看图纸样式</p>
					<p>4.请尽可能提供更多图纸，已让设计师了解项目</p>
				</div>
				<div class="bottom-guidelines">
					<steps
						:unactivecolor="'rgba(204, 204, 204, 0.5)'"
						:activecolor="'#e60000'"
						:active="active"
						:step="step"
						@allClick="allClick"
					></steps>
				</div>
			</div>
		</div>
		<!-- 预估金额 -->
		<div class="guidelines-i6-img" ref="priceSum" v-show="active == 6">
			<img class="img-line" src="../assets/imgs/tu7@2x.png" alt="" />
			<div class="guidelines-i6">
				<img class="bg-border-i6" src="../assets/imgs/kuang7@2x.png" alt="" />
				<div class="title-guidelines">
					预估金额
					<div class="jump-next" @click="allClick('out')">跳过</div>
				</div>

				<div class="content-guidelines"> 第五步：查看下单需求的预估金额，确认下单信息 </div>
				<div class="bottom-guidelines">
					<steps
						:unactivecolor="'rgba(204, 204, 204, 0.5)'"
						:activecolor="'#e60000'"
						:active="active"
						:step="step"
						@allClick="allClick"
					></steps>
				</div>
			</div>
		</div>
		<!-- 确认订单 -->
		<div class="guidelines-i7-img" ref="submitBtn_confirm" v-show="active == 7">
			<img class="img-line" src="../assets/imgs/tu8@2x.png" alt="" />
			<div class="guidelines-i7">
				<img class="bg-border-i7" src="../assets/imgs/kuang8@2x.png" alt="" />
				<div class="title-guidelines">
					确认下单
					<div class="jump-next" @click="allClick('out')">跳过</div>
				</div>

				<div class="content-guidelines">
					最后一步：提交下单信息，订单数据实时同步，详细信息可在订单管理查看
				</div>
				<div class="bottom-guidelines">
					<steps
						:unactivecolor="'rgba(204, 204, 204, 0.5)'"
						:activecolor="'#e60000'"
						:active="active"
						:step="step"
						@allClick="allClick"
					></steps>
				</div>
			</div>
		</div>
		<!-- 保存草稿 -->
		<div class="guidelines-i8-img" ref="submitBtn_save" v-show="active == 8">
			<img class="img-line" src="../assets/imgs/tu9@2x.png" alt="" />
			<div class="guidelines-i8">
				<img class="bg-border-i8" src="../assets/imgs/kuang8@2x.png" alt="" />
				<div class="title-guidelines">
					保存草稿
					<div class="jump-next" @click="allClick('out')">跳过</div>
				</div>

				<div class="content-guidelines">
					可对下单页面填写的信息进行保存草稿箱保存，供下次继续查找信息
				</div>
				<div class="bottom-guidelines">
					<steps
						:active="active"
						:unactivecolor="'rgba(204, 204, 204, 0.5)'"
						:activecolor="'#e60000'"
						:step="step"
						@allClick="allClick"
					></steps>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import steps from './stepMask.vue';
	export default {
		components: {
			steps,
		},
		props: {
			getDomposition: {
				type: Object,
			},
		},
		data() {
			return {
				timer: null,
				active: 0,
				step: 9,
				leftProcess: null,
				essential: null,
				ruleForm: null,
				serveForm: null,
				imgUpload: null,
				priceSum: null,
				submitBtn: null,
				stepDom: [
					null,
					{ name: 'leftProcess', difference: -120 },
					{ name: 'essential', difference: -120 },
					{ name: 'ruleForm', difference: -120 },
					{ name: 'serveForm', difference: -120 },
					{ name: 'imgUpload', difference: 0 },
					{ name: 'priceSum', difference: 0 },
					{ name: 'submitBtn', difference: 0 },
					{ name: 'submitBtn', difference: 0 },
				],
			};
		},
		computed: {},
		watch: {
			leftProcess(newVal) {
				if (newVal) {
					this.$refs['leftProcess'].style.top = newVal.y + 'px';
					this.$refs['leftProcess'].style.left = newVal.x + 'px';
				}
			},
			essential(newVal) {
				if (newVal) {
					this.$refs['essential'].style.top = newVal.y + 'px';
					this.$refs['essential'].style.left = Number(newVal.x) + 20 + 'px';
				}
			},
			ruleForm(newVal) {
				if (newVal) {
					this.$refs['ruleForm'].style.top = newVal.y + 'px';
					this.$refs['ruleForm'].style.left = Number(newVal.x) + 20 + 'px';
				}
			},
			serveForm(newVal) {
				if (newVal) {
					this.$refs['serveForm'].style.top = newVal.y + 'px';
					this.$refs['serveForm'].style.left = Number(newVal.x) + 10 + 'px';
				}
			},
			imgUpload(newVal) {
				if (newVal) {
					this.$refs['imgUpload'].style.top = newVal.y + 'px';
					this.$refs['imgUpload'].style.left = Number(newVal.x) - 20 + 'px';
				}
			},
			priceSum(newVal) {
				if (newVal) {
					this.$refs['priceSum'].style.top = newVal.y + 'px';
					this.$refs['priceSum'].style.left = Number(newVal.x) + 'px';
				}
			},
			submitBtn(newVal) {
				if (newVal) {
					this.$refs['submitBtn_confirm'].style.top = newVal.y - 20 + 'px';
					this.$refs['submitBtn_confirm'].style.left = Number(newVal.x) + 160 + 'px';

					this.$refs['submitBtn_save'].style.top = newVal.y - 20 + 'px';
					this.$refs['submitBtn_save'].style.left = Number(newVal.x) - 6 + 'px';
				}
			},
		},
		beforeCreate() {},
		created() {},
		beforeMount() {},
		mounted() {
			const loading = this.$loading({
				lock: true,
				text: '加载中，请耐心等待....',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)',
			});
			setTimeout(() => {
				this.getPosition();
				this.onClientWidth().listeners().listenerScroll();
				loading.close();
			}, 3000);
		},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {
			this.scrollChange().remove();
		},
		destroyed() {},
		methods: {
			// 操作滚动条
			scrollChange() {
				const fn = (e) => {
					e.preventDefault();
				};
				const fn_1 = (num) => {
					const top = window.scrollY + num;
					// console.log("执行", top, window.scrollY, window.scrollTop, num);
					window.scrollTo({
						top,
					});
				};

				const callback = {
					change: (num) => {
						fn_1(num);
						return callback;
					},
					linsteners: () => {
						// document.body.style.overflow = "hidden";
						document.addEventListener('touchmove', fn, false);
						return callback;
					},
					remove: () => {
						// document.body.style.overflow = "inherit";
						document.removeEventListener('touchmove', fn, false);
						return callback;
					},
				};

				return callback;
			},

			onClientWidth() {
				const fn = () => {
					window.onresize = () => {
						return (() => {
							this.getPosition();
						})();
					};
				};
				const fn_1 = () => {
					return this.getPosition();
				};
				const callback = {
					listeners: () => {
						fn();
						return callback;
					},
					listenerScroll: () => {
						window.addEventListener('scroll', fn_1);
						return callback;
					},
					removeScroll: () => {
						window.removeEventListener('scroll', fn_1);
						return callback;
					},
				};
				return callback;
			},
			allClick(type, val) {
				if (this.timer) {
					clearTimeout(this.timer);
				}
				this.timer = setTimeout(() => {
					switch (type) {
						// 上一步
						case 'up':
							this.upGuidelines();
							break;
						// 下一步
						case 'next':
							this.nextGuidelines();
							break;
						// 退出 跳过
						case 'out':
							this.jumpGuidelines();
							break;
						// 完成 结束
						case 'over':
							this.confirm();
							break;
						// 指定active
						case 'change':
							this.changeActive(val);
							break;
					}
				}, 400);
			},
			// 跳出 指引
			jumpGuidelines() {
				this.$emit('changeGuidelinesEject', false);
			},
			// 下一步指引
			nextGuidelines() {
				let num = Number(this.active) + 1;
				this.changeActive(num);
			},
			// 上一步指引
			upGuidelines() {
				let num = Number(this.active) - 1;
				this.changeActive(num);
			},
			// 完成
			confirm() {
				this.$emit('changeGuidelinesEject', false);
			},
			// 更改
			changeActive(val) {
				let refDom = this.stepDom[val];
				if (refDom) {
					const top = this.$data[refDom.name].top || this.$data[refDom.name].y || 0;
					const height = refDom.difference;
					const num = top + height || 0;
					this.$emit('getGuidelinesNumber', val);
					this.scrollChange().change(num);
				}

				this.active = val;
			},
			getPosition() {
				this.$emit('getDomposition', (data) => {
					Object.keys(data).forEach((item) => {
						this.$set(this.$data, item, data[item]);
					});
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.bg-w {
		background-color: #ffffff !important;
		color: #333333 !important;
	}
	.mask-guidelines {
		position: fixed;
		top: 0px;
		left: 0px;
		width: 100%;
		min-height: 100vh;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
		z-index: 100;

		.guidelines-i8 {
			display: flex;
			flex-direction: column;
			position: absolute;
			bottom: 100px;
			left: 50%;
			transform: translateX(-50%);
			z-index: 3;
			padding: 38px 30px 30px;
			width: 487px;
			height: 257px;
			.bg-border-i8 {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100% !important;
				height: 100% !important;
			}
		}

		.guidelines-i7 {
			display: flex;
			flex-direction: column;
			position: absolute;
			bottom: 100px;
			left: 50%;
			transform: translateX(-50%);
			z-index: 3;
			padding: 38px 30px 30px;
			width: 487px;
			height: 257px;
			.bg-border-i7 {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100% !important;
				height: 100% !important;
			}
		}

		.guidelines-i6 {
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 0px;
			left: -530px;
			z-index: 4;
			padding: 38px 30px 30px;
			width: 498px;
			height: 219px;
			.bg-border-i6 {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100% !important;
				height: 100% !important;
			}
		}

		.guidelines-i5 {
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 0px;
			left: 480px;
			z-index: 4;
			padding: 38px 30px 30px;
			width: 498px;
			height: 330px;
			.bg-border-i5 {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100% !important;
				height: 100% !important;
			}
		}

		.guidelines-i4 {
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 256px;
			left: 20px;
			z-index: 4;
			padding: 38px 30px 30px;
			width: 487px;
			height: 314px;
			.bg-border-i4 {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100% !important;
				height: 100% !important;
			}
		}
		.guidelines-i3 {
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 320px;
			left: 20px;
			z-index: 4;
			padding: 38px 30px 30px;
			width: 487px;
			height: 396px;

			.bg-border-i3 {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100% !important;
				height: 100% !important;
			}
		}
		.guidelines-i2 {
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 180px;
			left: 20px;
			z-index: 4;
			padding: 38px 30px 30px;
			width: 487px;
			height: 228px;

			.bg-border-i2 {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100% !important;
				height: 100% !important;
			}
		}
		.guidelines-i1 {
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 0px;
			left: calc(var(--proportion) * 220px);
			z-index: 10;
			padding: 38px 30px 30px;
			width: 497px;
			height: 221px;
			.bg-border-i1 {
				position: absolute;
				top: 0px;
				left: 0px;
				width: 100% !important;
				height: 100% !important;
			}
		}
		.guidelines-i0 {
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 274px;
			left: 50%;
			z-index: 10;
			transform: translateX(-50%);
			padding: 38px 30px 30px;
			width: 665px;
			height: 252px;
			// border: 2px solid rgba(255, 255, 255, 0.5);
		}
	}
	.title-guidelines {
		position: relative;
		z-index: 1;
		width: 100%;
		font-size: 22px;
		// font-weight: bold;
		color: #333;

		.jump-next:active {
			opacity: 0.5;
		}
		.jump-next {
			position: absolute;
			top: 50%;
			right: 0px;
			transform: translateY(-50%);
			font-size: 16px;
			font-weight: 400;
			color: rgba(153, 153, 153, 0.75);
			cursor: pointer;
		}
	}
	.content-guidelines {
		position: relative;
		z-index: 1;
		margin-top: 30px;
		font-size: 16px;
		font-weight: 400;
		color: #333;
		span {
			color: #e60000;
		}
		p {
			line-height: 24px;
		}
	}
	.bottom-guidelines {
		position: absolute;
		bottom: 30px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: calc(100% - 60px);
		height: 40px;

		// .fixed-points {
		//   display: flex;
		//   align-items: center;
		//   .point-item.active {
		//     opacity: 1;
		//   }
		//   .point-item:active {
		//     opacity: 0.8;
		//   }
		//   .point-item {
		//     margin-right: 8px;
		//     width: 10px;
		//     height: 10px;
		//     background: #ffffff;
		//     border-radius: 50%;
		//     opacity: 0.5;
		//     cursor: pointer;
		//   }
		// }
	}
	.options-guide-next {
		cursor: pointer;
		width: 100px;
		height: 40px;
		background: #e60000;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
		font-weight: 500;
		color: #ffffff;
	}
	.options-guide-next:active,
	.options-guide-out:active,
	.options-guide-up:active {
		opacity: 0.7;
	}
	.options-guide-out,
	.options-guide-up {
		cursor: pointer;
		width: 100px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		font-size: 16px;
		font-weight: 500;
		color: #ffffff;
		opacity: 0.75;
	}
	.options-guidelines {
		display: flex;
		align-items: center;
	}
	.guidelines-i1-img {
		position: absolute;
		top: 127px;
		left: calc(var(--proportion) * 183px);
		z-index: 10;
		.img-line {
			max-width: calc(var(--proportion) * 188px);
			max-height: calc(var(--proportion) * 553px);
		}
	}

	.guidelines-i2-img {
		position: absolute;
		top: 228px;
		left: calc(var(--proportion) * 624px);
		z-index: 9;
		overflow: hidden;
		width: calc(var(--proportion) * 1000px);
		min-height: 600px;
		min-width: 840px;
		.img-line {
			max-width: 1000px;
			object-fit: cover;
		}
	}
	.guidelines-i3-img {
		position: absolute;
		top: 414px;
		left: calc(var(--proportion) * 624px);
		z-index: 8;
		overflow: hidden;
		width: calc(var(--proportion) * 1000px);
		min-height: 800px;
		min-width: 840px;
		.img-line {
			max-width: 1000px;
			object-fit: cover;
		}
	}
	.guidelines-i4-img {
		position: absolute;
		top: 747px;
		left: calc(var(--proportion) * 600px);
		z-index: 7;
		overflow: hidden;
		width: calc(var(--proportion) * 1080px);
		min-height: 800px;
		min-width: 840px;
		.img-line {
			max-width: 1030px;
			object-fit: cover;
		}
	}
	.guidelines-i5-img {
		position: absolute;
		top: 1200px;
		left: calc(var(--proportion) * 624px);
		z-index: 6;
		width: calc(var(--proportion) * 800px);

		min-height: 800px;
		min-width: 840px;
		.img-line {
			max-width: 458px;
			object-fit: cover;
		}
	}
	.guidelines-i6-img {
		position: absolute;
		top: 1200px;
		left: calc(var(--proportion) * 1024px);
		z-index: 6;
		width: calc(var(--proportion) * 600px);
		min-height: 600px;
		min-width: 640px;
		.img-line {
			max-width: calc(var(--proportion) * 490px);
			min-width: 440px;
			object-fit: cover;
		}
	}
	.guidelines-i7-img {
		position: absolute;
		top: 1500px;
		left: calc(var(--proportion) * 680px);
		z-index: 6;
		width: calc(var(--proportion) * 200px);
		min-height: 88px;
		min-width: 200px;
		.img-line {
			max-width: calc(var(--proportion) * 200px);
			min-width: 200px;
			object-fit: cover;
		}
	}
	.guidelines-i8-img {
		position: absolute;
		top: 1500px;
		left: calc(var(--proportion) * 680px);
		z-index: 6;
		width: calc(var(--proportion) * 200px);
		min-height: 88px;
		min-width: 200px;
		.img-line {
			max-width: calc(var(--proportion) * 200px);
			min-width: 200px;
			object-fit: cover;
		}
	}
</style>
